export const emailTaskAction = item => ({
  type:"email_task_accept",suggestion_id:item.id,
  ...(item.status==="accepting"?item.accepted_payload:{title:item.title,estimated_minutes:item.estimated_minutes,priority:item.priority,source_fingerprint:item.source_fingerprint}),
  preview:{verified:true,email_subject:item.email_subject,evidence:item.evidence,due:item.due,
    planning:item.status==="accepting"?item.accepted_planning:item.planning},
});

export const validEmailTaskReview=value=>{
  if(!value||!Number.isInteger(value.total)||value.total<0||!Number.isInteger(value.scan_pending)||value.scan_pending<0||typeof value.limited!=="boolean")return false;
  if(value.total===0)return value.next===null;
  const item=value.next;
  return !!item&&/^[a-f0-9]{64}$/.test(item.id)&&item.path===`/tasks?suggestion=${item.id}`&&typeof item.title==="string"&&!!item.title.trim()&&item.title.length<=200&&typeof item.needs_resume==="boolean"&&typeof item.urgent_review==="boolean"&&(item.due==null||typeof item.due==="string"&&Number.isFinite(Date.parse(item.due)));
};
